var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAhLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 287.4 128.9",
    style: {
      enableBackground: "new 0 0 287.4 128.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.4,38.9l-2.4,7h-5.1l9.6-27.7h6.5l10,27.7h-5.5l-2.5-7H120.4L120.4,38.9z M129.6,34.6 c-2.2-6.3-3.5-10.1-4.2-12.5h0c-0.7,2.6-2.1,7.1-3.9,12.5H129.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.4,18.3v16.6c0,5.7,3,7.4,6.2,7.4c3.7,0,6.1-1.9,6.1-7.4V18.3h5.2v16.3c0,9.3-5.3,11.8-11.4,11.8 s-11.3-2.6-11.3-11.6V18.3L146.4,18.3L146.4,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.4,18.3h18.8v4.3h-13.7v7.5h12.9v4.3h-12.9v11.5h-5.1L170.4,18.3L170.4,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.4,42.1l15.8-19.5h-15v-4.3h20.9v4.2l-15.3,19.1h16l-0.7,4.3h-21.7L192.4,42.1L192.4,42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.9,18.3v16.6c0,5.7,3,7.4,6.2,7.4c3.7,0,6.1-1.9,6.1-7.4V18.3h5.2v16.3c0,9.3-5.3,11.8-11.4,11.8 c-6,0-11.3-2.6-11.3-11.6V18.3L223.9,18.3L223.9,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.6,45.9h-3.8c-0.2-0.7-0.4-1.8-0.4-3.1c-1.4,2-4,3.5-8.3,3.5c-8,0-12.4-6.1-12.4-14 c0-8.3,4.7-14.6,13.3-14.6c6.9,0,11,3.8,11.7,8.6h-5.2c-0.7-2.3-2.4-4.5-6.6-4.5c-5.9,0-7.9,4.9-7.9,10.2s2.1,10,7.8,10 c5.7,0,6.6-3.7,6.6-7v-0.3h-6.7v-4.3h11.7V45.9L271.6,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.7,60.1h5.2v11.1h12.3V60.1h5.2v27.7h-5.2V75.4h-12.3v12.3h-5.2V60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164,75.5h-13.4v8h14.8l-0.6,4.3h-19.2V60.1h19.1v4.3h-14v6.8H164L164,75.5L164,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.2,60.1h5.2v23.4h14l-0.6,4.3h-18.6V60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194,60.1h10.6c8,0,13.2,5.3,13.2,13.5s-5.1,14.2-13.4,14.2H194V60.1z M199.2,83.5h4.9c5.7,0,8.3-4.2,8.3-9.9 c0-4.8-2.4-9.3-8.3-9.3h-5V83.5L199.2,83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.2,75.5h-13.4v8h14.8l-0.6,4.3h-19.2V60.1h19.1v4.3h-14v6.8h13.4L242.2,75.5L242.2,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.4,87.8V60.1h6.5c3.6,6.3,10.8,18.4,12.2,21.4h0.1c-0.3-3.1-0.3-7.8-0.3-12.3v-9.1h4.8v27.7h-6.2 c-3.2-5.6-11-19.2-12.4-22.3H253c0.2,2.7,0.2,8,0.2,13v9.3L248.4,87.8L248.4,87.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.7,109.4h1.8v4c0.3-0.5,1-1.1,2.2-1.1c2,0,3.1,1.6,3.1,3.8c0,2.1-1.1,4.1-3.3,4.1c-1.1,0-1.7-0.4-2-1 c0,0.3,0,0.6-0.1,0.8h-1.7c0-0.8,0-1.6,0-2.5V109.4L115.7,109.4z M121,116.2c0-1.4-0.6-2.3-1.7-2.3c-1.3,0-1.8,0.9-1.8,2.5 c0,1.4,0.4,2.4,1.7,2.4C120.3,118.7,121,117.7,121,116.2L121,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.9,112.5c0.9,2.9,1.6,5.1,1.7,5.8h0c0.2-0.8,0.7-2.5,1.7-5.8h1.8l-2.6,7.7c-0.7,2.2-1.3,2.8-3,2.8 c-0.2,0-0.6,0-0.9-0.1v-1.5c0.2,0,0.4,0,0.6,0c0.8,0,1.2-0.3,1.5-1.3l-2.7-7.7L125.9,112.5L125.9,112.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.9,110h3.9c2.9,0,4.8,1.9,4.8,4.9c0,3-1.9,5.2-4.9,5.2h-3.8L136.9,110L136.9,110z M138.8,118.5h1.8 c2.1,0,3-1.5,3-3.6c0-1.8-0.9-3.4-3-3.4h-1.8L138.8,118.5L138.8,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.7,109.4h1.8v1.8h-1.8V109.4z M147.7,112.5h1.8v7.5h-1.8V112.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.5,119.2c0,2.4-0.9,3.9-3.6,3.9c-2.7,0-3.2-1.4-3.3-2.3h1.8c0.2,0.6,0.6,1,1.5,1c1.5,0,1.8-0.9,1.8-2.5 v-0.4c-0.4,0.7-1,1.1-2.2,1.1c-1.9,0-3.1-1.6-3.1-3.6c0-2.4,1.4-3.9,3.3-3.9c1.3,0,1.9,0.6,2,1c0-0.2,0.1-0.7,0.1-0.9h1.7 c0,0.6,0,1.4,0,2.2L158.5,119.2L158.5,119.2z M153.3,116.2c0,1.4,0.7,2.2,1.7,2.2c1.4,0,1.7-0.9,1.7-2.3c0-1.4-0.3-2.3-1.7-2.3 C154,113.8,153.3,114.7,153.3,116.2L153.3,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.9,109.4h1.8v1.8h-1.8V109.4z M160.9,112.5h1.8v7.5h-1.8V112.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.4,112.5h1.2v-2.1h1.8v2.1h1.5v1.4h-1.5v3.9c0,0.6,0.2,0.9,0.8,0.9c0.1,0,0.4,0,0.5,0v1.3 c-0.4,0.1-0.9,0.1-1.3,0.1c-1.4,0-1.9-0.7-1.9-2v-4.2h-1.2L164.4,112.5L164.4,112.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.6,118.2c0,0.7,0.1,1.6,0.1,1.8H175c-0.1-0.2-0.1-0.5-0.1-0.8c-0.3,0.4-0.8,1-2.2,1 c-1.8,0-2.5-1.2-2.5-2.3c0-1.7,1.3-2.5,3.6-2.5h1.1v-0.5c0-0.6-0.2-1.2-1.3-1.2c-1,0-1.2,0.5-1.3,1h-1.7c0.1-1.2,0.9-2.3,3.1-2.3 c1.9,0,3,0.8,3,2.5V118.2L176.6,118.2z M174.8,116.5h-1c-1.3,0-1.9,0.4-1.9,1.2c0,0.6,0.4,1.1,1.2,1.1c1.5,0,1.7-1,1.7-2.1 L174.8,116.5L174.8,116.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179,120v-10.7h1.8V120H179z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.7,117.1c0.2,1.1,1,1.6,2.3,1.6s1.8-0.6,1.8-1.4c0-0.9-0.5-1.3-2.3-1.7c-2.6-0.6-3.3-1.6-3.3-2.9 c0-1.7,1.2-2.9,3.6-2.9c2.6,0,3.6,1.4,3.8,2.8h-1.9c-0.1-0.7-0.5-1.4-1.9-1.4c-1,0-1.6,0.4-1.6,1.2s0.5,1.1,2.1,1.5 c2.9,0.7,3.5,1.8,3.5,3.2c0,1.8-1.3,3-3.9,3c-2.6,0-3.8-1.3-4-3L188.7,117.1L188.7,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.4,119.3v3.6h-1.8v-8.6c0-0.6,0-1.2,0-1.8h1.8c0,0.2,0.1,0.7,0.1,1c0.3-0.6,1-1.2,2.3-1.2 c1.7,0,3,1.4,3,3.7c0,2.7-1.4,4.1-3.3,4.1C199.3,120.2,198.7,119.8,198.4,119.3L198.4,119.3z M201.9,116.2c0-1.4-0.6-2.3-1.7-2.3 c-1.3,0-1.8,0.8-1.8,2.4s0.4,2.5,1.7,2.5C201.3,118.7,201.9,117.8,201.9,116.2L201.9,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.7,109.4h1.8v1.8h-1.8V109.4z M205.7,112.5h1.8v7.5h-1.8V112.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.9,114.4c0-0.6,0-1.3,0-1.9h1.8c0,0.2,0.1,0.8,0.1,1c0.3-0.5,0.9-1.2,2.2-1.2c1.5,0,2.5,1,2.5,2.9v4.8 h-1.8v-4.6c0-0.9-0.3-1.6-1.3-1.6c-1.1,0-1.6,0.7-1.6,2.1v4.1h-1.8L209.9,114.4L209.9,114.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.2,116.7c0,1.1,0.6,2.1,1.7,2.1c1,0,1.3-0.4,1.5-0.9h1.8c-0.3,0.9-1.1,2.4-3.3,2.4c-2.4,0-3.5-1.9-3.5-3.8 c0-2.3,1.2-4,3.5-4c2.5,0,3.4,1.9,3.4,3.7c0,0.2,0,0.4,0,0.6L220.2,116.7L220.2,116.7z M223.4,115.5c0-1-0.5-1.8-1.6-1.8 c-1.1,0-1.6,0.8-1.7,1.8H223.4L223.4,115.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.9,98.4c-0.5,0-1.1-0.1-1.6-0.4l-37-21.3c-1-0.6-1.6-1.6-1.6-2.7V31.2c0-1.1,0.6-2.1,1.6-2.7l37-21.3 c1-0.6,2.2-0.6,3.1,0l37,21.3c1.5,0.9,2,2.8,1.1,4.3c-0.9,1.5-2.8,2-4.3,1.1L52.9,13.5L19,33v39.1l33.8,19.5l35.4-20.4 c1.5-0.9,3.4-0.3,4.3,1.1c0.9,1.5,0.3,3.4-1.1,4.3l-37,21.3C53.9,98.2,53.4,98.4,52.9,98.4L52.9,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.9,46.9c-1.1,0-2.1-0.6-2.7-1.6c-0.9-1.5-0.3-3.4,1.1-4.3l21-12.1c1-0.6,2.2-0.6,3.1,0l21,12.1 c1.5,0.9,2,2.8,1.1,4.3c-0.9,1.5-2.8,2-4.3,1.1L52.9,35.3L33.5,46.5C33,46.8,32.4,46.9,31.9,46.9L31.9,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.9,68.3c-1.1,0-2.1-0.6-2.7-1.6c-0.9-1.5-0.3-3.4,1.1-4.3l21-12.1c1-0.6,2.2-0.6,3.1,0l21,12.1 c1.5,0.9,2,2.8,1.1,4.3c-0.9,1.5-2.8,2-4.3,1.1L52.9,56.7L33.5,67.9C33,68.2,32.4,68.3,31.9,68.3L31.9,68.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhLogoWhite);
export default __webpack_public_path__ + "static/media/ah_logo_white.66709a1322d979bebd10d9185bae5972.svg";
export { ForwardRef as ReactComponent };